import { getQueryBoundary } from '@confluence/query-preloader-boundary/entry-points/queryBoundaryStorage.ts';

type DiagnosticFields = Record<string, boolean | number | string | null | undefined>;

function getRuntime(): 'server' | 'client' {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	return process.env.REACT_SSR || typeof window === 'undefined' ? 'server' : 'client';
}

function getBoundaryName(): string {
	try {
		return getQueryBoundary() ?? 'none';
	} catch {
		return 'unknown';
	}
}

function formatDiagnosticValue(value: boolean | number | string | null | undefined): string {
	return String(value ?? 'none').replace(/"/g, '\\"');
}

export function logRelayMigrationDiagnostic(
	eventName: string,
	fields: DiagnosticFields = {},
): void {
	const fieldText = Object.entries({
		runtime: getRuntime(),
		boundary: getBoundaryName(),
		...fields,
	})
		.map(([key, value]) => `${key}="${formatDiagnosticValue(value)}"`)
		.join(' ');

	// eslint-disable-next-line no-console
	console.log(`[Relay migration] ${eventName} ${fieldText}`);
}
